<div class="row justify-content-center align-items-center p-0" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-center txt-primario">Detalle cobertura</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-card-content class="py-0">
    @if (data.cobertura.cve_coberturak == 3) {
      <div class="row">
        <div class="col-md-12 text-center">
          <strong>Siniestro {{data.detalleCoberturasResumen.extras.tipo}} :
            {{data.detalleCoberturasResumen.extras.siniestro}}
          </strong>
        </div>
        <div class="col-md-12 text-center">
          <strong>Total estimado: </strong>
          <strong>{{data.detalleCoberturasResumen.extras.Total_estimado}}</strong>
        </div>
      </div>
    }
    <div class="row mt-2">
      <div class="col-md-12">
        @if (datosCoberturas.data.length > 0) {
          <mat-table [dataSource]="datosCoberturas" class="mat-elevation-z8">
            <!-- Columnas dinámicas -->
            @for (columna of columnas; track columna) {
              <ng-container [matColumnDef]="columna">
                <mat-header-cell *matHeaderCellDef> {{ columna == 'rc_catastrofico' ? 'Catastrofico' : columna == 'id_tercero' ? 'Tercero' : columna | titlecase }} </mat-header-cell>
                <mat-cell *matCellDef="let elemento"> {{ elemento[columna] }} </mat-cell>
                <mat-footer-cell *matFooterCellDef>
                  {{ columnasTotales.includes(columna) ? procesarTotal(columna) : 'Total' }}
                </mat-footer-cell>
              </ng-container>
            }
            <mat-header-row *matHeaderRowDef="columnas"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnas;"></mat-row>
            <mat-footer-row *matFooterRowDef="columnas"></mat-footer-row>
          </mat-table>
        } @else {
          <div class="mensaje-vacio">No hay datos disponibles.</div>
        }


      </div>
    </div>
  </mat-card-content>
</mat-dialog-content>
<mat-card-actions class="row justify-content-end mx-0">
  <div class="col-md-auto col-auto">
    <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Aceptar')">
      Cerrar
    </button>
  </div>
</mat-card-actions>